export const materials = [
  {
    materialCode: 510,
    category: "Detectors",
    materialDescription: "Patress Base",
    itemRefPrice: 2.2,
  },
  // Smoke Mains At beginning so that they come up first when searched.
  {
    materialCode: 511,
    category: "Detectors",
    materialDescription: "Smoke det (mains/wireless/10)",
    itemRefPrice: 50.5,
  },
  {
    materialCode: 512,
    category: "Detectors",
    materialDescription: "Heat det (mains/wireless/10)",
    itemRefPrice: 50.5,
  },
  {
    materialCode: 513,
    category: "Detectors",
    materialDescription: "CO det (mains/wireless/10)",
    itemRefPrice: 50.5,
  },

  //////////////////////////////////////////////////////////////////////
  {
    materialCode: 514,
    category: "Detectors",
    materialDescription: "Smoke det (mains/10)",
    itemRefPrice: 33.0,
  },
  {
    materialCode: 515,
    category: "Detectors",
    materialDescription: "Heat det (mains/10)",
    itemRefPrice: 33.0,
  },
  {
    materialCode: 516,
    category: "Detectors",
    materialDescription: "CO det (mains/10)",
    itemRefPrice: 33.0,
  },

  ////////////////////////////////
  {
    materialCode: 517,
    category: "Detectors",
    materialDescription: "Smoke det (mains/9v)",
    itemRefPrice: 18.0,
  },
  {
    materialCode: 518,
    category: "Detectors",
    materialDescription: "Heat det (mains/9v)",
    itemRefPrice: 18.0,
  },
  {
    materialCode: 519,
    category: "Detectors",
    materialDescription: "CO det (mains/9v)",
    itemRefPrice: 33.0,
  },

  ///////// Wireless
  {
    materialCode: 520,
    category: "Detectors",
    materialDescription: "Smoke det (wireless/10)",
    itemRefPrice: 20.0,
  },
  {
    materialCode: 521,
    category: "Detectors",
    materialDescription: "Heat det (wireless/10)",
    itemRefPrice: 20.0,
  },
  {
    materialCode: 522,
    category: "Detectors",
    materialDescription: "CO det (wireless/10)",
    itemRefPrice: 22.74,
  },
  {
    materialCode: 523,
    category: "Detectors",
    materialDescription: "Control Panel (wireless/10)",
    itemRefPrice: 36.0,
  },

  ////////////////////////////////////////////////////////////////////////////////////////
  {
    materialCode: 1,
    category: "None",
    materialDescription: "None required.",
    itemRefPrice: 0,
  },
  {
    materialCode: 2,
    category: "1 Lighting",
    materialDescription: "Pendant",
    itemRefPrice: 3.65,
  },
  {
    materialCode: 3,
    category: "1 Lighting",
    materialDescription: "Batten Holder",
    itemRefPrice: 3.95,
  },
  {
    materialCode: 4,
    category: "1 Lighting",
    materialDescription: "Lamp Holder",
    itemRefPrice: 1.85,
  },
  {
    materialCode: 5,
    category: "1 Lighting",
    materialDescription: "Light Switch (1 Gang)",
    itemRefPrice: 1.89,
  },
  {
    materialCode: 6,
    category: "1 Lighting",
    materialDescription: "Light Switch (2 Gang)",
    itemRefPrice: 2.59,
  },
  {
    materialCode: 7,
    category: "1 Lighting",
    materialDescription: "Light Switch (3 Gang)",
    itemRefPrice: 5.37,
  },
  {
    materialCode: 8,
    category: "1 Lighting",
    materialDescription: "Dimmer Switch (1 Gang) 450w",
    itemRefPrice: 11.79,
  },
  {
    materialCode: 9,
    category: "1 Lighting",
    materialDescription: "Dimmer Switch (2 Gang) 450w",
    itemRefPrice: 14.9,
  },
  {
    materialCode: 10,
    category: "1 Lighting",
    materialDescription: "Dimmer Switch (1 Gang) 1000w",
    itemRefPrice: 16.89,
  },
  {
    materialCode: 11,
    category: "1 Lighting",
    materialDescription: "Rosering",
    itemRefPrice: 1.88,
  },
  {
    materialCode: 12,
    category: "1 Lighting",
    materialDescription: "Pullcord Switch (6A)",
    itemRefPrice: 5.36,
  },

  {
    materialCode: 13,
    category: "1 Lighting",
    materialDescription: "Connector (5 - 15A)",
    itemRefPrice: 0.2,
  },
  {
    materialCode: 14,
    category: "1 Lighting",
    materialDescription: "Connector (30A)",
    itemRefPrice: 0.3,
  },
  {
    materialCode: 15,
    category: "1 Lighting",
    materialDescription: "Connector (45A)",
    itemRefPrice: 0.4,
  },
  {
    materialCode: 16,
    category: "1 Lighting",
    materialDescription: "Earth Sleeve",
    itemRefPrice: 0.5,
  },
  {
    materialCode: 17,
    category: "1 Lighting",
    materialDescription: "Phase Sleeve",
    itemRefPrice: 0.5,
  },
  {
    materialCode: 18,
    category: "1 Lighting",
    materialDescription: "Starter",
    itemRefPrice: 0.9,
  },
  {
    materialCode: 19,
    category: "1 Lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 20,
    category: "1 Lighting",
    materialDescription: "Flourescent Lamp (8w)",
    itemRefPrice: 1.5,
  },
  {
    materialCode: 21,
    category: "1 Lighting",
    materialDescription: "Flourescent Lamp (2ft)",
    itemRefPrice: 2.89,
  },
  {
    materialCode: 22,
    category: "1 Lighting",
    materialDescription: "Flourescent Lamp (3ft)",
    itemRefPrice: 3.19,
  },
  {
    materialCode: 23,
    category: "1 Lighting",
    materialDescription: "Flourescent Lamp (4ft)",
    itemRefPrice: 3.39,
  },
  {
    materialCode: 24,
    category: "1 Lighting",
    materialDescription: "Flourescent Lamp (5ft)",
    itemRefPrice: 3.43,
  },
  {
    materialCode: 25,
    category: "1 Lighting",
    materialDescription: "Flourescent Lamp (6ft)",
    itemRefPrice: 3.59,
  },
  {
    materialCode: 26,
    category: "1 Lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 27,
    category: "1 Lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 28,
    category: "1 Lighting",
    materialDescription: "Flourescent Fitting (5ft) Single",
    itemRefPrice: 16.95,
  },
  {
    materialCode: 29,
    category: "1 Lighting",
    materialDescription: "Flourescent Fitting (5ft) Single with diffuser",
    itemRefPrice: 25.9,
  },
  {
    materialCode: 30,
    category: "1 Lighting",
    materialDescription: "Flourescent Fitting (6ft) Single",
    itemRefPrice: 22.79,
  },
  {
    materialCode: 31,
    category: "1 Lighting",
    materialDescription: "Flourescent Fitting (6ft) Single with diffuser",
    itemRefPrice: 29.9,
  },
  {
    materialCode: 32,
    category: "1 Lighting",
    materialDescription: "Flourescent Fitting (6ft) Twin",
    itemRefPrice: 29.75,
  },
  {
    materialCode: 33,
    category: "1 Lighting",
    materialDescription: "Flourescent light supension clips",
    itemRefPrice: 1.5,
  },
  {
    materialCode: 34,
    category: "1 Lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 35,
    category: "1 Lighting",
    materialDescription: "Circular Drum Fitting (2D,28w)IP65",
    itemRefPrice: 28,
  },
  {
    materialCode: 36,
    category: "-",
    materialDescription: "Circular Drum Fitting (LED)IP65",
    itemRefPrice: 30,
  },
  {
    materialCode: 37,
    category: "2 Lamps",
    materialDescription: "70w Son E Lamp",
    itemRefPrice: 9.79,
  },
  {
    materialCode: 38,
    category: "2 Lamps",
    materialDescription: "70w Son I Lamp",
    itemRefPrice: 11.23,
  },
  {
    materialCode: 39,
    category: "2 Lamps",
    materialDescription: "Halogen (300w)",
    itemRefPrice: 2.2,
  },
  {
    materialCode: 40,
    category: "2 Lamps",
    materialDescription: "Halogen (500w)",
    itemRefPrice: 2.7,
  },
  {
    materialCode: 41,
    category: "2 Lamps",
    materialDescription: "PL Lamp (7w)",
    itemRefPrice: 3.93,
  },
  {
    materialCode: 42,
    category: "2 Lamps",
    materialDescription: "PL Lamp (11w)",
    itemRefPrice: 4.27,
  },
  {
    materialCode: 43,
    category: "2 Lamps",
    materialDescription: "PL Lamp (18w)",
    itemRefPrice: 4.59,
  },
  {
    materialCode: 44,
    category: "1 Lighting",
    materialDescription: "Circular Dome Fitting whi (100w)",
    itemRefPrice: 17.89,
  },
  {
    materialCode: 45,
    category: "1 Lighting",
    materialDescription: "Emergency light LED (3hr-n/m)",
    itemRefPrice: 22.5,
  },
  {
    materialCode: 46,
    category: "1 Lighting",
    materialDescription: "Emergency light LED (3hr-n/m) metal",
    itemRefPrice: 33,
  },
  {
    materialCode: 48,
    category: "Power",
    materialDescription: "Socket (Sw/Double)",
    itemRefPrice: 3.5,
  },
  {
    materialCode: 49,
    category: "Power",
    materialDescription: "Socket (Sw/Single)",
    itemRefPrice: 2.9,
  },
  {
    materialCode: 50,
    category: "Power",
    materialDescription: "Backbox (Single/Mtl.)",
    itemRefPrice: 1.89,
  },
  {
    materialCode: 51,
    category: "Power",
    materialDescription: "Backbox (Double/Mtl.)",
    itemRefPrice: 2.11,
  },
  {
    materialCode: 52,
    category: "Power",
    materialDescription: "Backbox (Single/Mtl.) Deep",
    itemRefPrice: 2.22,
  },
  {
    materialCode: 53,
    category: "Power",
    materialDescription: "Backbox (Double/Mtl.) Deep",
    itemRefPrice: 2.89,
  },
  {
    materialCode: 54,
    category: "Power",
    materialDescription: "Spur- sw/fused with neon",
    itemRefPrice: 9.22,
  },
  {
    materialCode: 55,
    category: "Power",
    materialDescription: "Spur- sw/fused",
    itemRefPrice: 8.44,
  },
  {
    materialCode: 56,
    category: "Power",
    materialDescription: "Spur- fused",
    itemRefPrice: 7.69,
  },
  {
    materialCode: 57,
    category: "Power",
    materialDescription: "20A Dbl/pole sw. with neon",
    itemRefPrice: 8.44,
  },
  {
    materialCode: 58,
    category: "Power",
    materialDescription: "20A Dbl/pole switch",
    itemRefPrice: 7.97,
  },
  {
    materialCode: 59,
    category: "Power",
    materialDescription: "30A Dbl/pole switch + neon (Crabtree)",
    itemRefPrice: 11.82,
  },
  {
    materialCode: 60,
    category: "Power",
    materialDescription: "45A Dbl/pole switch + neon",
    itemRefPrice: 11.44,
  },
  {
    materialCode: 61,
    category: "Power",
    materialDescription: "45A Dbl/pole pullcord switch + neon",
    itemRefPrice: 12.62,
  },
  {
    materialCode: 62,
    category: "Power",
    materialDescription: "Backbox (Single/dry line)",
    itemRefPrice: 1.23,
  },
  {
    materialCode: 63,
    category: "Power",
    materialDescription: "Backbox (Double/dry line)",
    itemRefPrice: 1.89,
  },
  {
    materialCode: 64,
    category: "Power",
    materialDescription: "Backbox (Circular/dry line)",
    itemRefPrice: 2.35,
  },
  {
    materialCode: 65,
    category: "Power",
    materialDescription: "Shaver socket (240 & 110v)",
    itemRefPrice: 33.59,
  },
  {
    materialCode: 66,
    category: "Power",
    materialDescription: "Patress Box (Sgl.) 35mm",
    itemRefPrice: 1.05,
  },
  {
    materialCode: 67,
    category: "Power",
    materialDescription: "Patress Box (Dbl.) 35mm",
    itemRefPrice: 1.22,
  },
  {
    materialCode: 68,
    category: "Power",
    materialDescription: "D.B. Blank",
    itemRefPrice: 0.89,
  },
  {
    materialCode: 70,
    category: "8 Cookers",
    materialDescription: "Cooker flex outlet plate",
    itemRefPrice: 7.47,
  },
  {
    materialCode: 71,
    category: "8 Cookers",
    materialDescription: "Cooker control unit MK5011",
    itemRefPrice: 28.16,
  },
  {
    materialCode: 72,
    category: "8 Cookers",
    materialDescription: "Cooker control unit (skt + neons)",
    itemRefPrice: 14.69,
  },
  {
    materialCode: 73,
    category: "8 Cookers",
    materialDescription: "Cooker control unit (with skt.)",
    itemRefPrice: 12.82,
  },
  {
    materialCode: 74,
    category: "8 Cookers",
    materialDescription: "Cooker control unit (vertical with neon)",
    itemRefPrice: 12.82,
  },
  {
    materialCode: 75,
    category: "8 Cookers",
    materialDescription: "Cooker flex outlet plate MK",
    itemRefPrice: 9.89,
  },
  {
    materialCode: 76,
    category: "8 Cookers",
    materialDescription: "Cooker Cable (6mm)",
    itemRefPrice: 2.21,
  },
  {
    materialCode: 77,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 78,
    category: "7 Heating",
    materialDescription: "Potterton EP3002 Prog.",
    itemRefPrice: 64.86,
  },
  {
    materialCode: 79,
    category: "7 Heating",
    materialDescription: "ST699 Programmer",
    itemRefPrice: 56.92,
  },
  {
    materialCode: 80,
    category: "7 Heating",
    materialDescription: "Set 1E Programmer",
    itemRefPrice: 41.85,
  },
  {
    materialCode: 81,
    category: "7 Heating",
    materialDescription: "Set 2E Programmer",
    itemRefPrice: 46.72,
  },
  {
    materialCode: 82,
    category: "7 Heating",
    materialDescription: "Horst. E7 Programmer",
    itemRefPrice: 64.56,
  },
  {
    materialCode: 83,
    category: "7 Heating",
    materialDescription: "715 Electronic htg. Programmer",
    itemRefPrice: 46.18,
  },
  {
    materialCode: 84,
    category: "7 Heating",
    materialDescription: "Boss white sealant",
    itemRefPrice: 1.5,
  },
  {
    materialCode: 85,
    category: "7 Heating",
    materialDescription: '"7" Stat."',
    itemRefPrice: 6.9,
  },
  {
    materialCode: 86,
    category: "7 Heating",
    materialDescription: '"11" Stat."',
    itemRefPrice: 7.18,
  },
  {
    materialCode: 87,
    category: "7 Heating",
    materialDescription: '"18" Stat."',
    itemRefPrice: 7.97,
  },
  {
    materialCode: 88,
    category: "7 Heating",
    materialDescription: '"11" Immerser htg. Element"',
    itemRefPrice: 12.75,
  },
  {
    materialCode: 89,
    category: "7 Heating",
    materialDescription: '"18" Immerser htg. Element"',
    itemRefPrice: 13.2,
  },
  {
    materialCode: 90,
    category: "7 Heating",
    materialDescription: '"27" Immerser htg. Element"',
    itemRefPrice: 13.75,
  },
  {
    materialCode: 91,
    category: "7 Heating",
    materialDescription: "Electrisaver Electr. Immerser sw.",
    itemRefPrice: 34.22,
  },
  {
    materialCode: 92,
    category: "7 Heating",
    materialDescription: "Roomstat (electronic)",
    itemRefPrice: 13.89,
  },
  {
    materialCode: 93,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 95,
    category: "3 Fire",
    materialDescription: "9v Battery",
    itemRefPrice: 1.95,
  },
  {
    materialCode: 96,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 97,
    category: "3 Fire",
    materialDescription: "Smoke detector 240v with batt.",
    itemRefPrice: 22.5,
  },
  {
    materialCode: 98,
    category: "3 Fire",
    materialDescription: "Smoke detector 240v with batt./hush.opt",
    itemRefPrice: 25,
  },
  {
    materialCode: 99,
    category: "3 Fire",
    materialDescription: "Surface mount plate (detector)",
    itemRefPrice: 3.65,
  },
  {
    materialCode: 100,
    category: "999 Misc",
    materialDescription: "Screw/s",
    itemRefPrice: 0.1,
  },
  {
    materialCode: 101,
    category: "999 Misc",
    materialDescription: "Screws/plugs",
    itemRefPrice: 0.15,
  },
  {
    materialCode: 102,
    category: "999 Misc",
    materialDescription: "Insulation tape",
    itemRefPrice: 0.3,
  },
  {
    materialCode: 103,
    category: "999 Misc",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 104,
    category: "999 Misc",
    materialDescription: "Gyproc anchor/s",
    itemRefPrice: 0.35,
  },
  {
    materialCode: 105,
    category: "999 Misc",
    materialDescription: "Gyproc screw/s",
    itemRefPrice: 0.1,
  },
  {
    materialCode: 106,
    category: "999 Misc",
    materialDescription: "M3.5x50 Skt/screw/s",
    itemRefPrice: 0.25,
  },
  {
    materialCode: 107,
    category: "999 Misc",
    materialDescription: "M3.5x75 Skt/screw/s",
    itemRefPrice: 0.33,
  },
  {
    materialCode: 108,
    category: "999 Misc",
    materialDescription: "M4x50 Brass screw/s",
    itemRefPrice: 0.2,
  },
  {
    materialCode: 109,
    category: "999 Misc",
    materialDescription: "8x3 Long screw/s",
    itemRefPrice: 0.2,
  },
  {
    materialCode: 110,
    category: "999 Misc",
    materialDescription: "8x1 Screw/s",
    itemRefPrice: 0.1,
  },
  {
    materialCode: 111,
    category: "999 Misc",
    materialDescription: "Grommet/s",
    itemRefPrice: 0.22,
  },
  {
    materialCode: 112,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 113,
    category: "4 Fuses",
    materialDescription: "Fuse (3A)",
    itemRefPrice: 0.44,
  },
  {
    materialCode: 114,
    category: "4 Fuses",
    materialDescription: "Fuse (5A)",
    itemRefPrice: 0.44,
  },
  {
    materialCode: 115,
    category: "4 Fuses",
    materialDescription: "Fuse (13A)",
    itemRefPrice: 0.49,
  },
  {
    materialCode: 116,
    category: "4 Fuses",
    materialDescription: "Fuse 6A Slidelock",
    itemRefPrice: 3.12,
  },
  {
    materialCode: 117,
    category: "4 Fuses",
    materialDescription: "Fuse 63A Mains supply",
    itemRefPrice: 9.27,
  },
  {
    materialCode: 118,
    category: "4 Fuses",
    materialDescription: "Fuse 80A Mains supply",
    itemRefPrice: 9.93,
  },
  {
    materialCode: 119,
    category: "4 Fuses",
    materialDescription: "Mains fuse Cartridge hldr.",
    itemRefPrice: 11.22,
  },
  {
    materialCode: 120,
    category: "4 Fuses",
    materialDescription: "Mini fuse (1A)",
    itemRefPrice: 1.18,
  },
  {
    materialCode: 121,
    category: "4 Fuses",
    materialDescription: "Mini fuse (2A)",
    itemRefPrice: 1.38,
  },
  {
    materialCode: 122,
    category: "4 Fuses",
    materialDescription: "Mini fuse (3A)",
    itemRefPrice: 1.57,
  },
  {
    materialCode: 123,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 124,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 125,
    category: "5 Testing",
    materialDescription: "Test fee (void)",
    itemRefPrice: 15,
  },
  {
    materialCode: 126,
    category: "5 Testing",
    materialDescription: "Test fee (occupied)",
    itemRefPrice: 24,
  },
  {
    materialCode: 127,
    category: "5 Testing",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 128,
    category: "5 Testing",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 129,
    category: "5 Testing",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 130,
    category: "5 Testing",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 131,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 132,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 133,
    category: "6 Plumbing",
    materialDescription: "Elbow 15mm Comp.",
    itemRefPrice: 2.69,
  },
  {
    materialCode: 134,
    category: "6 Plumbing",
    materialDescription: "Tee 15mm Comp.",
    itemRefPrice: 1.21,
  },
  {
    materialCode: 135,
    category: "6 Plumbing",
    materialDescription: "Straight 15mm Comp.",
    itemRefPrice: 1.21,
  },
  {
    materialCode: 136,
    category: "6 Plumbing",
    materialDescription: "Stop end 15mm Comp.",
    itemRefPrice: 1.21,
  },
  {
    materialCode: 137,
    category: "6 Plumbing",
    materialDescription: "Acorn pipe 15mm",
    itemRefPrice: 1.79,
  },
  {
    materialCode: 138,
    category: "6 Plumbing",
    materialDescription: "Acorn pipe 22mm",
    itemRefPrice: 1.99,
  },
  {
    materialCode: 139,
    category: "6 Plumbing",
    materialDescription: "Washing machine hose",
    itemRefPrice: 2.99,
  },
  {
    materialCode: 140,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 141,
    category: "999 Misc",
    materialDescription: "Cover cleanser",
    itemRefPrice: 0.3,
  },
  {
    materialCode: 142,
    category: "999 Misc",
    materialDescription: "WD40",
    itemRefPrice: 0.3,
  },
  {
    materialCode: 143,
    category: "999 Misc",
    materialDescription: "Filler",
    itemRefPrice: 0.3,
  },
  {
    materialCode: 144,
    category: "999 Misc",
    materialDescription: "Earth Clamp",
    itemRefPrice: 1.5,
  },
  {
    materialCode: 145,
    category: "999 Misc",
    materialDescription: "Earth crimp (6mm)",
    itemRefPrice: 0.33,
  },
  {
    materialCode: 146,
    category: "999 Misc",
    materialDescription: "Silicone sealant",
    itemRefPrice: 1,
  },
  {
    materialCode: 147,
    category: "999 Misc",
    materialDescription: "Plugtop",
    itemRefPrice: 1.5,
  },
  {
    materialCode: 148,
    category: "999 Misc",
    materialDescription: "Blank plate (single)",
    itemRefPrice: 0.98,
  },
  {
    materialCode: 149,
    category: "999 Misc",
    materialDescription: "Blank plate (double)",
    itemRefPrice: 1.46,
  },
  {
    materialCode: 150,
    category: "999 Misc",
    materialDescription: "Plaster (Small bag)",
    itemRefPrice: 3.22,
  },
  {
    materialCode: 151,
    category: "999 Misc",
    materialDescription: "Plaster (Large bag)",
    itemRefPrice: 6.9,
  },
  {
    materialCode: 152,
    category: "999 Misc",
    materialDescription: "Trunking (16x25) Adhsv.",
    itemRefPrice: 5.22,
  },
  {
    materialCode: 153,
    category: "999 Misc",
    materialDescription: "Trunking (16x25) Non-Adhsv.",
    itemRefPrice: 4.45,
  },
  {
    materialCode: 154,
    category: "999 Misc",
    materialDescription: "Trunking (40x25) Non-Adhsv.",
    itemRefPrice: 8.69,
  },
  {
    materialCode: 155,
    category: "999 Misc",
    materialDescription: "Retractive switch kit (Mk)",
    itemRefPrice: 22.5,
  },
  {
    materialCode: 156,
    category: "999 Misc",
    materialDescription: "Purlin beam susp. Clamp",
    itemRefPrice: 1.56,
  },
  {
    materialCode: 157,
    category: "999 Misc",
    materialDescription: "Purlin beam Conduit clamp",
    itemRefPrice: 1.49,
  },
  {
    materialCode: 158,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 159,
    category: "9 Cables",
    materialDescription: "T&E 1.0mm (2c)",
    itemRefPrice: 0.48,
  },
  {
    materialCode: 160,
    category: "9 Cables",
    materialDescription: "T&E 1.0mm (3c)",
    itemRefPrice: 0.79,
  },
  {
    materialCode: 161,
    category: "9 Cables",
    materialDescription: "T&E 1.5mm (2c)",
    itemRefPrice: 0.58,
  },
  {
    materialCode: 162,
    category: "9 Cables",
    materialDescription: "T&E 1.5mm (3c)",
    itemRefPrice: 0.88,
  },
  {
    materialCode: 163,
    category: "9 Cables",
    materialDescription: "T&E 2.5mm (2c)",
    itemRefPrice: 0.85,
  },
  {
    materialCode: 164,
    category: "9 Cables",
    materialDescription: "T&E 4.0mm (2c)",
    itemRefPrice: 1.94,
  },
  {
    materialCode: 165,
    category: "9 Cables",
    materialDescription: "T&E 6.0mm (2c)",
    itemRefPrice: 2.2,
  },
  {
    materialCode: 166,
    category: "9 Cables",
    materialDescription: "T&E 10mm (2c)",
    itemRefPrice: 3.49,
  },
  {
    materialCode: 167,
    category: "9 Cables",
    materialDescription: "2.5mm Butle cable",
    itemRefPrice: 1.39,
  },
  {
    materialCode: 168,
    category: "9 Cables",
    materialDescription: "2.5mm Earth wire",
    itemRefPrice: 0.45,
  },
  {
    materialCode: 169,
    category: "9 Cables",
    materialDescription: "6.0mm Earth wire",
    itemRefPrice: 0.67,
  },
  {
    materialCode: 170,
    category: "9 Cables",
    materialDescription: "10 mm Earth wire",
    itemRefPrice: 1.47,
  },
  {
    materialCode: 171,
    category: "9 Cables",
    materialDescription: "16 mm Earth wire",
    itemRefPrice: 1.66,
  },
  {
    materialCode: 172,
    category: "9 Cables",
    materialDescription: "25 mm Earth wire",
    itemRefPrice: 2.69,
  },
  {
    materialCode: 173,
    category: "9 Cables",
    materialDescription: "Alarm cable",
    itemRefPrice: 0.44,
  },
  {
    materialCode: 174,
    category: "9 Cables",
    materialDescription: "Clips (Plastic-small)",
    itemRefPrice: 0.07,
  },
  {
    materialCode: 175,
    category: "9 Cables",
    materialDescription: "Cable - Cat5",
    itemRefPrice: 0.63,
  },
  {
    materialCode: 176,
    category: "9 Cables",
    materialDescription: "Clips (Plastic-large)",
    itemRefPrice: 0.09,
  },
  {
    materialCode: 177,
    category: "9 Cables",
    materialDescription: "Clips (Metal-small)",
    itemRefPrice: 0.04,
  },
  {
    materialCode: 178,
    category: "9 Cables",
    materialDescription: "Clips (Metal-large)",
    itemRefPrice: 0.05,
  },
  {
    materialCode: 179,
    category: "9 Cables",
    materialDescription: "Tyraps",
    itemRefPrice: 0.2,
  },
  {
    materialCode: 180,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 181,
    category: "Storge heaters",
    materialDescription: "Thermal overload link",
    itemRefPrice: 7.39,
  },
  {
    materialCode: 182,
    category: "Storge heaters",
    materialDescription: "Storage Htr. Dimp. XL12",
    itemRefPrice: 187.8,
  },
  {
    materialCode: 183,
    category: "Storge heaters",
    materialDescription: "Storage Htr. Dimp. XL18",
    itemRefPrice: 206.79,
  },
  {
    materialCode: 184,
    category: "Storge heaters",
    materialDescription: "Storage Htr. Dimp. XL24",
    itemRefPrice: 227.89,
  },
  {
    materialCode: 185,
    category: "Storge heaters",
    materialDescription: "Storage/4 elem.",
    itemRefPrice: 0,
  },
  {
    materialCode: 186,
    category: "Storge heaters",
    materialDescription: "Storage/2 elem.",
    itemRefPrice: 0,
  },
  {
    materialCode: 187,
    category: "Storge heaters",
    materialDescription: "Storage/3 elem.",
    itemRefPrice: 0,
  },
  {
    materialCode: 188,
    category: "-",
    materialDescription: "",
    itemRefPrice: 0,
  },
  {
    materialCode: 189,
    category: "Circuit breakers",
    materialDescription: "Wylex slot in mcb (6A)",
    itemRefPrice: 11.29,
  },
  {
    materialCode: 190,
    category: "Circuit breakers",
    materialDescription: "Wylex slot in mcb (10A)",
    itemRefPrice: 11.69,
  },
  {
    materialCode: 191,
    category: "Circuit breakers",
    materialDescription: "Wylex slot in mcb (15A)",
    itemRefPrice: 11.89,
  },
  {
    materialCode: 192,
    category: "Circuit breakers",
    materialDescription: "Wylex slot in mcb (30A)",
    itemRefPrice: 12.59,
  },
  {
    materialCode: 193,
    category: "Circuit breakers",
    materialDescription: "Wylex slot in mcb (45A)",
    itemRefPrice: 12.79,
  },
  {
    materialCode: 194,
    category: "Circuit breakers",
    materialDescription: "MCB/s  MEM",
    itemRefPrice: 7.49,
  },
  {
    materialCode: 195,
    category: "Circuit breakers",
    materialDescription: "MCB/s  Mk",
    itemRefPrice: 9.86,
  },
  {
    materialCode: 196,
    category: "Circuit breakers",
    materialDescription: "MCB/s  CrabT",
    itemRefPrice: 8.67,
  },
  {
    materialCode: 197,
    category: "Circuit breakers",
    materialDescription: "MCB/s  Wylex",
    itemRefPrice: 6.88,
  },
  {
    materialCode: 198,
    category: "Circuit breakers",
    materialDescription: "MCB/s  Hager",
    itemRefPrice: 8.67,
  },
  {
    materialCode: 199,
    category: "Circuit breakers",
    materialDescription: "-",
  },
  {
    materialCode: 200,
    category: "-",
    materialDescription: "-",
  },
  {
    materialCode: 201,
    category: "Focal fires",
    materialDescription: "Dimplex 314che",
    itemRefPrice: 185,
  },
  {
    materialCode: 202,
    category: "Focal fires",
    materialDescription: "Dimplex 316che",
    itemRefPrice: 203.35,
  },
  {
    materialCode: 203,
    category: "Focal fires",
    materialDescription: "Glen 2103",
    itemRefPrice: 78.95,
  },
  {
    materialCode: 204,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 205,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 206,
    category: "Distrubution",
    materialDescription: "10 way MEM Dist. Board",
    itemRefPrice: 64.92,
  },
  {
    materialCode: 207,
    category: "Distrubution",
    materialDescription: "8 way MEM Dist. Board",
    itemRefPrice: 55.89,
  },
  {
    materialCode: 208,
    category: "Distrubution",
    materialDescription: "6 way MEM Dist. Board",
    itemRefPrice: 48.37,
  },
  {
    materialCode: 209,
    category: "Distrubution",
    materialDescription: "4 way MEM Dist. Board",
    itemRefPrice: 42.44,
  },
  {
    materialCode: 210,
    category: "Distrubution",
    materialDescription: "Wylex 12w Consumer Unit with rcd (metal)",
    itemRefPrice: 73.5,
  },
  {
    materialCode: 211,
    category: "Distrubution",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 212,
    category: "Distrubution",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 213,
    category: "Distrubution",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 214,
    category: "Distrubution",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 215,
    category: "Distrubution",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 216,
    category: "Distrubution",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 217,
    category: "999 Misc",
    materialDescription: "Rubber gasket",
    itemRefPrice: 1.29,
  },
  {
    materialCode: 218,
    category: "999 Misc",
    materialDescription: "Trs Gland 20mm pvc",
    itemRefPrice: 0.52,
  },
  {
    materialCode: 219,
    category: "999 Misc",
    materialDescription: "Trs Gland 20mm brass",
    itemRefPrice: 1.06,
  },
  {
    materialCode: 220,
    category: "999 Misc",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 221,
    category: "999 Misc",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 222,
    category: "Extractor fans",
    materialDescription: '"Extract fan (4") centrifugal with p/c"',
    itemRefPrice: 36.57,
  },
  {
    materialCode: 223,
    category: "Extractor fans",
    materialDescription: '"Extract fan (4") standard"',
    itemRefPrice: 22.5,
  },
  {
    materialCode: 224,
    category: "Extractor fans",
    materialDescription: '"Extract fan (4") standard with timer"',
    itemRefPrice: 24.9,
  },
  {
    materialCode: 225,
    category: "Extractor fans",
    materialDescription: '"Extract fan (4") standard with pullcord"',
    itemRefPrice: 27.89,
  },
  {
    materialCode: 226,
    category: "Extractor fans",
    materialDescription: '"Extract fan (4") centrifugal with timer"',
    itemRefPrice: 36.57,
  },
  {
    materialCode: 227,
    category: "Extractor fans",
    materialDescription: "Xpelair DX200",
    itemRefPrice: 66.37,
  },
  {
    materialCode: 228,
    category: "Extractor fans",
    materialDescription: "Xpelair DX200T",
    itemRefPrice: 74.69,
  },
  {
    materialCode: 229,
    category: "Extractor fans",
    materialDescription: "Xpelair DX200TH",
    itemRefPrice: 78.22,
  },
  {
    materialCode: 230,
    category: "Extractor fans",
    materialDescription: "Xpelair DX200P",
    itemRefPrice: 72.33,
  },
  {
    materialCode: 231,
    category: "Extractor fans",
    materialDescription: "Xpelair DX400",
    itemRefPrice: 88.69,
  },
  {
    materialCode: 232,
    category: "Extractor fans",
    materialDescription: "Vent Axia fan",
    itemRefPrice: 45.96,
  },
  {
    materialCode: 233,
    category: "Extractor fans",
    materialDescription: "Vent Axia solo fan",
    itemRefPrice: 49.89,
  },
  {
    materialCode: 234,
    category: "Extractor fans",
    materialDescription: "Vent Axia solo P fan",
    itemRefPrice: 74.75,
  },
  {
    materialCode: 235,
    category: "Extractor fans",
    materialDescription: "Vent Axia Lo-watt k fan",
    itemRefPrice: 137.91,
  },
  {
    materialCode: 236,
    category: "Extractor fans",
    materialDescription: "Nu-Aire Genie",
    itemRefPrice: 132.47,
  },
  {
    materialCode: 237,
    category: "Extractor fans",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 238,
    category: "Extractor fans",
    materialDescription: "Fan isolator switch",
    itemRefPrice: 5.29,
  },
  {
    materialCode: 239,
    category: "Extractor fans",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 241,
    category: "Door Entry",
    materialDescription: "12v Electric keeper",
    itemRefPrice: 23.89,
  },
  {
    materialCode: 242,
    category: "Door Entry",
    materialDescription: "900/KSLD Handset",
    itemRefPrice: 35.9,
  },
  {
    materialCode: 243,
    category: "Door Entry",
    materialDescription: "GDX Handset",
    itemRefPrice: 34.89,
  },
  {
    materialCode: 244,
    category: "Door Entry",
    materialDescription: "Décor cover plate",
    itemRefPrice: 5.32,
  },
  {
    materialCode: 245,
    category: "Door Entry",
    materialDescription: "801 Elvox handset",
    itemRefPrice: 32.29,
  },
  {
    materialCode: 246,
    category: "Door Entry",
    materialDescription: "Raytel handset",
    itemRefPrice: 33.93,
  },
  {
    materialCode: 247,
    category: "Door Entry",
    materialDescription: "Push button (Vandal res.)",
    itemRefPrice: 10.71,
  },
  {
    materialCode: 248,
    category: "Door Entry",
    materialDescription: "Speaker/mic. Unit",
    itemRefPrice: 31.73,
  },
  {
    materialCode: 249,
    category: "Door Entry",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 250,
    category: "Door Entry",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 251,
    category: "Close Lighting",
    materialDescription: "Coughtrie fitting (twin)",
    itemRefPrice: 54.89,
  },
  {
    materialCode: 252,
    category: "Close lighting",
    materialDescription: "Coughtrie fitting (quad)",
    itemRefPrice: 79.93,
  },
  {
    materialCode: 253,
    category: "Close lighting",
    materialDescription: "Jsb Fitting (twin)",
    itemRefPrice: 49.89,
  },
  {
    materialCode: 254,
    category: "Close lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 255,
    category: "Close lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 256,
    category: "Close lighting",
    materialDescription: "Photocell head (70Lux)",
    itemRefPrice: 14.86,
  },
  {
    materialCode: 257,
    category: "Close lighting",
    materialDescription: "Photocell remote 20mm (70Lux)",
    itemRefPrice: 12.59,
  },
  {
    materialCode: 258,
    category: "Close lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 259,
    category: "Close lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 260,
    category: "Close lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 261,
    category: "Close lighting",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 263,
    category: "TV",
    materialDescription: "Co-ax lead/s",
    itemRefPrice: 1.79,
  },
  {
    materialCode: 264,
    category: "TV",
    materialDescription: "Co-ax plate/s",
    itemRefPrice: 2.82,
  },
  {
    materialCode: 265,
    category: "TV",
    materialDescription: "Booster (2 way)",
    itemRefPrice: 12.75,
  },
  {
    materialCode: 266,
    category: "TV",
    materialDescription: "Booster (3 way)",
    itemRefPrice: 14.49,
  },
  {
    materialCode: 267,
    category: "TV",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 268,
    category: "TV",
    materialDescription: "Co-ax Y Splitter",
    itemRefPrice: 1.79,
  },
  {
    materialCode: 269,
    category: "TV",
    materialDescription: "Co-axial cable",
    itemRefPrice: 0.47,
  },
  {
    materialCode: 270,
    category: "TV",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 271,
    category: "TV",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 272,
    category: "TV",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 273,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 274,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 275,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 276,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 277,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 278,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 279,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 280,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 281,
    category: "-",
    materialDescription: "Bulb (60w)",
    itemRefPrice: 0.38,
  },
  {
    materialCode: 282,
    category: "-",
    materialDescription: "Bulb (100w)",
    itemRefPrice: 0.44,
  },
  {
    materialCode: 283,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 284,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 285,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 286,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 287,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 288,
    category: "Lamps",
    materialDescription: "-",
  },
  {
    materialCode: 289,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 290,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 291,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 292,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 293,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 294,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 295,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 296,
    category: "Lamps",
    materialDescription: "2D - 16w Flourescent Lamp (2 pin)",
    itemRefPrice: 4.14,
  },
  {
    materialCode: 297,
    category: "Lamps",
    materialDescription: "2D - 16w Flourescent Lamp (4 pin)",
    itemRefPrice: 4.44,
  },
  {
    materialCode: 298,
    category: "Lamps",
    materialDescription: "2D - 28w Flourescent Lamp (2 pin)",
    itemRefPrice: 4.88,
  },
  {
    materialCode: 299,
    category: "Lamps",
    materialDescription: "2D - 28w Flourescent Lamp (4 pin)",
    itemRefPrice: 5.17,
  },
  {
    materialCode: 300,
    category: "Lamps",
    materialDescription: "2D - 38w Flourescent Lamp (2 pin)",
    itemRefPrice: 5.67,
  },
  {
    materialCode: 301,
    category: "Lamps",
    materialDescription: "2D - 38w Flourescent Lamp (4 pin)",
    itemRefPrice: 6.29,
  },
  {
    materialCode: 302,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 303,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 304,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 305,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 306,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 307,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 308,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 309,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 310,
    category: "Lamps",
    materialDescription: "Spotlight/s60w ES",
    itemRefPrice: 1.39,
  },
  {
    materialCode: 311,
    category: "Lamps",
    materialDescription: "Spotlight/s40w SES",
    itemRefPrice: 1.29,
  },
  {
    materialCode: 312,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 313,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 314,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 315,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 316,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 317,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 318,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 319,
    category: "Lamps",
    materialDescription: "GU10 (50w)",
    itemRefPrice: 2.29,
  },
  {
    materialCode: 320,
    category: "Lamps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 321,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 322,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 323,
    category: "Tel.",
    materialDescription: "Tel. socket (master)",
    itemRefPrice: 6.76,
  },
  {
    materialCode: 324,
    category: "Tel.",
    materialDescription: "Tel. socket (slave)",
    itemRefPrice: 5.99,
  },
  {
    materialCode: 325,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 326,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 327,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 328,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 329,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 330,
    category: "Call Out Fee",
    materialDescription: "Flat rate call out fee",
    itemRefPrice: 50,
  },
  {
    materialCode: 331,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 332,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 333,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 334,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 335,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 336,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 337,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 338,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 339,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 340,
    category: "9 Cables",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 341,
    category: "9 Cables",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 342,
    category: "9 Cables",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 343,
    category: "9 Cables",
    materialDescription: "Double Insulated Cable  ( 6mm ) Per/Mtr",
    itemRefPrice: 2.73,
  },
  {
    materialCode: 344,
    category: "9 Cables",
    materialDescription: "Double Insulated Cable  (10mm) Per/Mtr",
    itemRefPrice: 2.89,
  },
  {
    materialCode: 345,
    category: "9 Cables",
    materialDescription: "Double Insulated Cable  (16mm) Per/Mtr",
    itemRefPrice: 3.09,
  },
  {
    materialCode: 346,
    category: "9 Cables",
    materialDescription: "Double Insulated Cable  (25mm) Per/Mtr",
    itemRefPrice: 3.63,
  },
  {
    materialCode: 347,
    category: "9 Cables",
    materialDescription: "Double Insulated Cable  (35mm) Per/Mtr",
    itemRefPrice: 3.99,
  },
  {
    materialCode: 348,
    category: "9 Cables",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 349,
    category: "9 Cables",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 350,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 1.5mm) P/mtr",
    itemRefPrice: 0.19,
  },
  {
    materialCode: 351,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 2.5mm) P/mtr",
    itemRefPrice: 0.33,
  },
  {
    materialCode: 352,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 6.0mm) P/mtr",
    itemRefPrice: 0.75,
  },
  {
    materialCode: 353,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 10mm ) P/mtr",
    itemRefPrice: 1.05,
  },
  {
    materialCode: 354,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 16mm ) P/mtr",
    itemRefPrice: 1.8,
  },
  {
    materialCode: 355,
    category: "9 Cables",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 356,
    category: "9 Cables",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 357,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 1.5mm)  Per/Drum/100",
    itemRefPrice: 15.76,
  },
  {
    materialCode: 358,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 2.5mm)  Per/Drum/100",
    itemRefPrice: 26.35,
  },
  {
    materialCode: 359,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 6.0mm)  Per/Drum/100",
    itemRefPrice: 65.9,
  },
  {
    materialCode: 360,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 10mm)   Per/Drum/100",
    itemRefPrice: 95.38,
  },
  {
    materialCode: 361,
    category: "9 Cables",
    materialDescription: "Single Core Cable   ( 16mm)   Per/Drum/100",
    itemRefPrice: 162.4,
  },
  {
    materialCode: 362,
    category: "Power",
    materialDescription: "Patress Box (Sgl.) 47mm",
    itemRefPrice: 1.52,
  },
  {
    materialCode: 363,
    category: "Power",
    materialDescription: "Patress Box (Dbl.) 47mm",
    itemRefPrice: 1.53,
  },
  {
    materialCode: 364,
    category: "-",
    materialDescription: "Chocbox",
    itemRefPrice: 1.15,
  },
  {
    materialCode: 365,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 366,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 367,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 368,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 369,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 370,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 371,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 372,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 373,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 374,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 375,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 376,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 377,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 378,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 379,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 380,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 381,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 382,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 383,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 384,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 385,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 386,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 387,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 388,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 389,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 390,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 391,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 392,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 393,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 394,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 395,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 396,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 397,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 398,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 399,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 400,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 401,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 402,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 403,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 404,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 405,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 406,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 407,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 408,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 409,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 410,
    category: "Crimps",
    materialDescription: "Crimps - Earth crimp (6mm)",
    itemRefPrice: 0.33,
  },
  {
    materialCode: 411,
    category: "Crimps",
    materialDescription: "Crimps - Lug - 10mm",
    itemRefPrice: 0.45,
  },
  {
    materialCode: 412,
    category: "Crimps",
    materialDescription: "Crimps - Lug - 16mm",
    itemRefPrice: 0.67,
  },
  {
    materialCode: 413,
    category: "Crimps",
    materialDescription: "Crimps - Lug - 25mm",
    itemRefPrice: 1.14,
  },
  {
    materialCode: 414,
    category: "Crimps",
    materialDescription: "Crimps - Lug - 35mm",
    itemRefPrice: 1.45,
  },
  {
    materialCode: 415,
    category: "Crimps",
    materialDescription: "Crimps - Lug - 50mm",
    itemRefPrice: 1.86,
  },
  {
    materialCode: 416,
    category: "Crimps",
    materialDescription: "Crimps - (Ylw/Straight) - M6",
    itemRefPrice: 0.36,
  },
  {
    materialCode: 417,
    category: "Crimps",
    materialDescription: "Crimps - (Ylw/lug) -  M6/4",
    itemRefPrice: 0.22,
  },
  {
    materialCode: 418,
    category: "Crimps",
    materialDescription: "Crimps - (Ylw/lug) -  M6/6",
    itemRefPrice: 0.24,
  },
  {
    materialCode: 419,
    category: "Crimps",
    materialDescription: "Crimps - (Ylw/lug) -  M6/8",
    itemRefPrice: 0.26,
  },
  {
    materialCode: 420,
    category: "Crimps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 421,
    category: "Crimps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 422,
    category: "Crimps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 423,
    category: "Crimps",
    materialDescription: "Crimps - Red - 1.5mm - Lug",
    itemRefPrice: 0.16,
  },
  {
    materialCode: 424,
    category: "Crimps",
    materialDescription: "Crimps - Red - 1.5mm -  Straight",
    itemRefPrice: 0.19,
  },
  {
    materialCode: 425,
    category: "Crimps",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 426,
    category: "Crimps",
    materialDescription: "Crimps - Blue - 2.5mm - Lug",
    itemRefPrice: 0.19,
  },
  {
    materialCode: 427,
    category: "Crimps",
    materialDescription: "Crimps - Blue - 2.5mm -  Straight",
    itemRefPrice: 0.22,
  },
  {
    materialCode: 428,
    category: "Crimps",
    materialDescription: "Crimps",
    itemRefPrice: 0,
  },
  {
    materialCode: 429,
    category: "Crimps",
    materialDescription: "Crimps",
    itemRefPrice: 0,
  },
  {
    materialCode: 430,
    category: "Crimps",
    materialDescription: "Crimps",
    itemRefPrice: 0,
  },
  {
    materialCode: 431,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 432,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 433,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 434,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 435,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 436,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 437,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 438,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 439,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 440,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 441,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 442,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 443,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 444,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 445,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 446,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 447,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 448,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 449,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 450,
    category: "Conduit    20mm   PVC",
    materialDescription: "Coupling",
    itemRefPrice: 0.34,
  },
  {
    materialCode: 451,
    category: "Conduit    20mm   PVC",
    materialDescription: "Saddle",
    itemRefPrice: 0.68,
  },
  {
    materialCode: 452,
    category: "Conduit    20mm   PVC",
    materialDescription: "Right Angled Conduit Bend",
    itemRefPrice: 1.39,
  },
  {
    materialCode: 453,
    category: "Conduit    20mm   PVC",
    materialDescription: "Conduit 20mm / Lgth",
    itemRefPrice: 3.88,
  },
  {
    materialCode: 454,
    category: "Conduit    20mm   PVC",
    materialDescription: "Adaptor (Female)",
    itemRefPrice: 0.55,
  },
  {
    materialCode: 455,
    category: "Conduit    20mm   PVC",
    materialDescription: "Adaptor (Male)",
    itemRefPrice: 0.45,
  },
  {
    materialCode: 456,
    category: "Conduit    20mm   PVC",
    materialDescription: "Box Lid",
    itemRefPrice: 0.58,
  },
  {
    materialCode: 457,
    category: "Conduit    20mm   PVC",
    materialDescription: "M4x12 Brass screw/s",
    itemRefPrice: 0.14,
  },
  {
    materialCode: 458,
    category: "Conduit    20mm   PVC",
    materialDescription: "End box",
    itemRefPrice: 1.34,
  },
  {
    materialCode: 459,
    category: "Conduit    20mm   PVC",
    materialDescription: "Angle box",
    itemRefPrice: 1.54,
  },
  {
    materialCode: 460,
    category: "Conduit    20mm   PVC",
    materialDescription: "Through box",
    itemRefPrice: 1.56,
  },
  {
    materialCode: 461,
    category: "Conduit    20mm   PVC",
    materialDescription: "Tee box",
    itemRefPrice: 1.72,
  },
  {
    materialCode: 462,
    category: "Conduit    20mm   PVC",
    materialDescription: "U box",
    itemRefPrice: 1.78,
  },
  {
    materialCode: 463,
    category: "Conduit    20mm   PVC",
    materialDescription: "4 Way box",
    itemRefPrice: 2.23,
  },
  {
    materialCode: 464,
    category: "Conduit    20mm   PVC",
    materialDescription: "Y box",
    itemRefPrice: 1.98,
  },
  {
    materialCode: 465,
    category: "Conduit    20mm   PVC",
    materialDescription: "Gregg",
    itemRefPrice: 4.82,
  },
  {
    materialCode: 466,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 467,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 468,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 469,
    category: "Conduit    20mm   PVC",
    materialDescription: "PVA Glue  (tub)",
    itemRefPrice: 4.98,
  },
  {
    materialCode: 470,
    category: "Conduit    20mm   PVC",
    materialDescription: "PVA Glue  (dash)",
    itemRefPrice: 0.25,
  },
  {
    materialCode: 471,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 472,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 473,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 474,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 475,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 476,
    category: "Conduit    20mm   PVC",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 477,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 478,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 479,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 480,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Conduit  20mm / Lgth  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 481,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Coupling  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 482,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Saddle  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 483,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Box Lid  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 484,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "End box  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 485,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Angle box  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 486,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Through box  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 487,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Tee box  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 488,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "U box  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 489,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Y box  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 490,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "4 way box  20mm  (Mtl)",
    itemRefPrice: 0,
  },
  {
    materialCode: 491,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Lockring  20mm  (Mtl)",
    itemRefPrice: 0.18,
  },
  {
    materialCode: 492,
    category: "Conduit    20mm  ( Mtl)",
    materialDescription: "Bush Brass 20mm",
    itemRefPrice: 0.79,
  },
  {
    materialCode: 493,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 494,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 495,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 496,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 497,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 498,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 499,
    category: "Msc.",
    materialDescription: "50A Dbl.Pole sw. w/neon short plate",
    itemRefPrice: 12.24,
  },
  {
    materialCode: 500,
    category: "Misc.",
    materialDescription: "50A Dbl.Pole sw. w/neon long plate",
    itemRefPrice: 13.7,
  },
  {
    materialCode: 501,
    category: "Misc.",
    materialDescription: "50A Dbl.Pole pullcord sw. w/neon",
    itemRefPrice: 12.65,
  },
  {
    materialCode: 502,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 503,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },
  {
    materialCode: 504,
    category: "Pirlin",
    materialDescription: "Pirlin chain clips",
    itemRefPrice: 0.93,
  },
  {
    materialCode: 505,
    category: "-",
    materialDescription: "Piirlin conduit clips",
    itemRefPrice: 0.89,
  },
  {
    materialCode: 506,
    category: "Pirlin",
    materialDescription: "Suspension chain/box",
    itemRefPrice: 10,
  },
  {
    materialCode: 507,
    category: "EICR Dom. Base rate",
    materialDescription: "EICR <6 circuits base rate",
    itemRefPrice: 120,
  },
  {
    materialCode: 508,
    category: "EICR Dom. Additional circuits",
    materialDescription: "EICR Additional circuit fee",
    itemRefPrice: 15,
  },
  {
    materialCode: 509,
    category: "EICR Comm. Base Rate",
    materialDescription: "EICR Base charge per circuit",
    itemRefPrice: 20,
  },
  {
    materialCode: 524,
    category: "-",
    materialDescription: "-",
    itemRefPrice: 0,
  },

  // // Smoke Mains
  // {
  //   materialCode: 511,
  //   category: "Detectors",
  //   materialDescription: "Smoke det (mains/wireless/10)",
  //   itemRefPrice: 50.5,
  // },
  // {
  //   materialCode: 512,
  //   category: "Detectors",
  //   materialDescription: "Heat det (mains/wireless/10)",
  //   itemRefPrice: 50.5,
  // },
  // {
  //   materialCode: 513,
  //   category: "Detectors",
  //   materialDescription: "CO det (mains/wireless/10)",
  //   itemRefPrice: 50.5,
  // },

  // /////////
  // {
  //   materialCode: 514,
  //   category: "Detectors",
  //   materialDescription: "Smoke det (mains/10)",
  //   itemRefPrice: 33.0,
  // },
  // {
  //   materialCode: 515,
  //   category: "Detectors",
  //   materialDescription: "Heat det (mains/10)",
  //   itemRefPrice: 33.0,
  // },
  // {
  //   materialCode: 516,
  //   category: "Detectors",
  //   materialDescription: "CO det (mains/10)",
  //   itemRefPrice: 33.0,
  // },

  // /////////
  // {
  //   materialCode: 517,
  //   category: "Detectors",
  //   materialDescription: "Smoke det (mains/9v)",
  //   itemRefPrice: 18.0,
  // },
  // {
  //   materialCode: 518,
  //   category: "Detectors",
  //   materialDescription: "Heat det (mains/9v)",
  //   itemRefPrice: 18.0,
  // },
  // {
  //   materialCode: 519,
  //   category: "Detectors",
  //   materialDescription: "CO det (mains/9v)",
  //   itemRefPrice: 33.0,
  // },

  // ///////// WIreless
  // {
  //   materialCode: 520,
  //   category: "Detectors",
  //   materialDescription: "Smoke det (wireless/10)",
  //   itemRefPrice: 20.0,
  // },
  // {
  //   materialCode: 521,
  //   category: "Detectors",
  //   materialDescription: "Heat det (wireless/10)",
  //   itemRefPrice: 20.0,
  // },
  // {
  //   materialCode: 522,
  //   category: "Detectors",
  //   materialDescription: "CO det (wireless/10)",
  //   itemRefPrice: 46.0,
  // },
  // {
  //   materialCode: 523,
  //   category: "Detectors",
  //   materialDescription: "Control Panel (wireless/10)",
  //   itemRefPrice: 36.0,
  // },

  /////////
  // {
  //   materialCode: 517,
  //   category: "Detectors",
  //   materialDescription: "Smoke det (mains/wireless/9v)",
  //   itemRefPrice: 33.0,
  // },
  // {
  //   materialCode: 518,
  //   category: "Detectors",
  //   materialDescription: "Heat det (mains/wireless/9v)",
  //   itemRefPrice: 33.0,
  // },
  // {
  //   materialCode: 519,
  //   category: "Detectors",
  //   materialDescription: "CO det (mains/wireless/9v)",
  //   itemRefPrice: 33.0,
  // },
];
